import React, { useEffect, useState } from "react";
import { Button, Container, Col, Form, Nav, Row, Image, Spinner } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg"
import { useFormik } from "formik";
import Modal from "react-awesome-modal";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  coachAddEducation,
  coachUpdateEducation,
  coachDeleteEducation,
  coachAddExperience,
  coachUpdateExperience,
  coachDeleteExperience,
  coachAddCertificate,
  coachDeleteCertificate,
  coachUpdateCertificate,
  coachAddTestimonial,
  coachDeleteTestimonial,
  coachUpdate,
  publishProfile,
} from "../../../utils/api";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";
import moment from 'moment'
const initialValuesEdu = {
  course: "",
  university_colleage: "",
};

const initialtestimonial = {
  name: "",
  company_name: "",
  description: "",
  image: "",
};

const initialValuesExp = {
  title: "",
  company_name: "",
  start_date: "",
  end_date: "",
  workexperience: "",
  isPresent: false, // Default state
};

const initialValuesCerti = {
  name: "",
  organization: "",
};

const educationSchema = Yup.object().shape({
  course: Yup.string().required("Course is required").max(150),
  university_colleage: Yup.string().required("University/College is required").max(150),
});

const MAX_FILE_SIZE = 5242880; //100KB

const validFileExtensions = {
  image: ["jpg", "gif", "png", "jpeg", "svg", "webp"],
};

function isValidFileType(fileName, fileType) {
  return (
    fileName &&
    validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
  );
}

const testimonialSchema = Yup.object().shape({
  name: Yup.string().required("name is required").max(30),
  company_name: Yup.string().required("Company is required").max(30),
  description: Yup.string().required("description is required").max(250),
  image: Yup.mixed()
    .required("Image is Required")
    .test("is-valid-type", "Not a valid image type", (value) =>
      isValidFileType(value && value.name.toLowerCase(), "image")
    )
    .test(
      "is-valid-size",
      "Max allowed size is 100KB",
      (value) => value && value.size <= MAX_FILE_SIZE
    ),
});

/*const experienceSchema = Yup.object().shape({
  title: Yup.string().required("Title is required").max(50),
  company_name: Yup.string().required("Company is required").max(50),
  start_date: Yup.string().required("Start Date is required"),
  end_date: Yup.string().required("End Date is required"),
});*/

const experienceSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title is required")
    .max(50, "Title must be at most 50 characters"),
  company_name: Yup.string()
    .required("Company is required")
    .max(50, "Company must be at most 50 characters"),
  //start_date: Yup.string().required("Start Date is required"),
  // Fields with logging
  /*end_date: Yup.string().when("isPresent", {
    is: false,
    then: Yup.string().required(() => {
      console.log("Validating end_date: Required");
      return "End Date is required";
    }),
    otherwise: Yup.string().notRequired(() => {
      console.log("Validating end_date: Not required");
      return true;
    }),
  }),*/
  start_date: Yup.date()
    .required("Start date is required."),
    //.max(Yup.ref('end_date'), "Start date must be before the end date."),
  end_date: Yup.date()
    .nullable()
    .test(
      "validate-dates",
      "End date must be after start date or required when not present.",
      function (value) {
        const { start_date, isPresent } = this.parent; // Access sibling fields
        console.log("parentparent",new Date(value) , new Date(start_date) ,new Date(value) > new Date(start_date))
        if (isPresent) return true; // Skip validation if 'isPresent' is true
        if (!value) return false; // 'end_date' is required if 'isPresent' is false
        return new Date(value) > new Date(start_date); // Validate date order
      }
    ),
  isPresent: Yup.boolean(),
  /*workexperience: Yup.number()
    .required("Work experience is required.")
    .min(0, "Work experience cannot be negative."),*/
});

const calculateWorkExperience = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date(); // Use the current date if `endDate` is null
  const diffInMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  return (diffInMonths / 12).toFixed(1); // Convert months to years and keep 1 decimal point
};

const certificateSchema = Yup.object().shape({
  name: Yup.string().required("Name is required").max(50),
  organization: Yup.string()
    .required("Issuing Organization is required")
    .max(100),
});

function CoachProfileProfessionalDetailsComponent(props) {
  const [educations, seteducations] = useState([]);
  const [experiences, setexperiences] = useState([]);
  const [certificates, setcertificates] = useState([]);
  const [testimonials, settestimonials] = useState([]);
  const navigate = useNavigate();
  const { getUserFromToken, user } = useUserContext();
  const [workexperience, setworkexperience] = useState(null);
  const [eduVisible, setEduvisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [expVisible, setExpVisible] = useState(false);
  const [testiVisible, setTestiVisible] = useState(false);
  const [certiVisible, setCertiVisible] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [isSubmitting, setisSubmitting] = useState(false);
  const [allYears, setAllYears] = useState([]);

  // State to track if editing
  const [editingEducation, setEditingEducation] = useState(false);
  const [currentEducation, setCurrentEducation] = useState(null);

  const [editingExperience, setEditingExperience] = useState(false);
  const [currentExperience, setCurrentExperience] = useState(null);

  const [editingCertificate, setEditingCertificate] = useState(false);
  const [currentCertificate, setCurrentCertificate] = useState(null);


  const [mode, setMode] = useState(null); // "education" or "experience"

  const generateYears = (startYear = 2000) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - startYear + 1 }, (_, i) => `${currentYear - i}`);
  };

  useEffect(() => {
    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    seteducations(user?.educations);
    settestimonials(user?.testimonials || []);
    setexperiences(user?.experiences);
    setcertificates(user?.certificates);
    setworkexperience(user?.workexperience);
    setAllYears(generateYears(2000)); // Dynamic Year List
  }, [user]);

  const onClickSave = async (values) => {
    try {

      setisSubmitting(true);

      // Handle edited education
      /*const editedEducation = educations?.filter((i) => i?.status === "edited");
      for (let index = 0; index < editedEducation?.length; index++) {
        const element = editedEducation[index];
        const formData = new FormData();
        formData.append("id", element?.id);
        formData.append("course", element?.course);
        formData.append("university_colleage", element?.university_colleage);
        if (element?.passing_year) {
          formData.append("passing_year", element?.passing_year);
        }
        await coachUpdateEducation(formData);
      }*/

      // handle new education
      const newEducation = educations?.filter((i) => i?.status === "new");
      for (let index = 0; index < newEducation?.length; index++) {
        const element = newEducation[index];
        const formData = new FormData();
        formData.append("course", element?.course);
        formData.append("university_colleage", element?.university_colleage);
        if(element?.passing_year != undefined){
          formData.append("passing_year", moment().format('YYYY-MM-DD'));
        }
        await coachAddEducation(formData);
      }

      const deletedEducation = educations?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedEducation?.length > 0) {
        const formData = new FormData();
        formData.append(
          "education_ids",
          `[${deletedEducation?.map((i) => i?.id)}]`
        );

        await coachDeleteEducation(formData);
      }



      if (workexperience > 0) {
        const formData = new FormData();
        formData.append("workexperience", workexperience);
        await coachUpdate(formData);
      }

      // handle certificate
      const newCertificate = certificates?.filter((i) => i?.status === "new");
      for (let index = 0; index < newCertificate?.length; index++) {
        const element = newCertificate[index];
        const formData = new FormData();
        formData.append("name", element?.name);

        formData.append("organization", element?.organization);

        await coachAddCertificate(formData);
      }

      const deletedCertificate = certificates?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedCertificate?.length > 0) {
        const formData = new FormData();
        formData.append(
          "certificate_ids",
          `[${deletedCertificate?.map((i) => i?.id)}]`
        );

        await coachDeleteCertificate(formData);
      }

      // handal testimonial
      const newTestimonial = testimonials?.filter((i) => i?.status === "new");
      for (let index = 0; index < newTestimonial?.length; index++) {
        const element = newTestimonial[index];
        const formData = new FormData();
        formData.append("name", element?.name);
        formData.append("company_name", element?.company_name);
        formData.append("description", element?.description);
        formData.append("testimonial_img", element?.image);
        await coachAddTestimonial(formData);
      }

      const deletedTestimonial = testimonials?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedTestimonial?.length > 0) {
        const formData = new FormData();
        formData.append(
          "tesimonial_ids",
          `[${deletedTestimonial?.map((i) => i?.id)}]`
        );

        await coachDeleteTestimonial(formData);
      }

      // Handle edited experience
      /*const editedExperience = experiences?.filter((i) => i?.status === "edited");
      for (let index = 0; index < editedExperience?.length; index++) {
        const element = editedExperience[index];
        //console.log('edit_element', element);
        const formData = new FormData();
        formData.append("id", element?.id);
        formData.append("title", element?.title);
        formData.append("company_name", element?.company_name);
        formData.append("start_date", element?.start_date);
        formData.append("end_date", element?.end_date);
        formData.append("workexperience", element?.workexperience);
        await coachUpdateExperience(formData);
      }*/

      // handle experience
      const newExperience = experiences?.filter((i) => i?.status === "new");
      for (let index = 0; index < newExperience?.length; index++) {
        const element = newExperience[index];
        const formData = new FormData();
        formData.append("title", element?.title);
        formData.append("company_name", element?.company_name);
        formData.append("start_date", element?.start_date);
        formData.append("end_date", element?.end_date);
        formData.append("workexperience", element?.workexperience);

        await coachAddExperience(formData);
      }

      const deletedExperience = experiences?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedExperience?.length > 0) {
        const formData = new FormData();
        formData.append(
          "experience_ids",
          `[${deletedExperience?.map((i) => i?.id)}]`
        );

        await coachDeleteExperience(formData);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      getUserFromToken();
      const publish_profile = await publishProfile();
      if (publish_profile) {
        toast.success("Profile updated successfully!");
      }
      setisSubmitting(false);
      navigate("/coach/profile");
    }
    /*getUserFromToken();
    const publish_profile = await publishProfile();
    if (publish_profile) {
      toast.success("Profile updated successfully!");
      setisSubmitting(false);
    }
    setisSubmitting(false);
    navigate("/coach/profile");*/
  };

  const onClickPreview = async (values) => {
    try {
      setisLoading(true);
      if (workexperience > 0) {
        const formData = new FormData();
        formData.append("workexperience", workexperience);
        await coachUpdate(formData);
      }

      // handle certificate
      const newCertificate = certificates?.filter((i) => i?.status === "new");
      for (let index = 0; index < newCertificate?.length; index++) {
        const element = newCertificate[index];
        const formData = new FormData();
        formData.append("name", element?.name);

        formData.append("organization", element?.organization);

        await coachAddCertificate(formData);
      }

      const deletedCertificate = certificates?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedCertificate?.length > 0) {
        const formData = new FormData();
        formData.append(
          "certificate_ids",
          `[${deletedCertificate?.map((i) => i?.id)}]`
        );

        await coachDeleteCertificate(formData);
      }

      // handle education
      const newEducation = educations?.filter((i) => i?.status === "new");
      for (let index = 0; index < newEducation?.length; index++) {
        const element = newEducation[index];
        const formData = new FormData();
        formData.append("course", element?.course);
        formData.append("university_colleage", element?.university_colleage);
        formData.append("passing_year", element?.passing_year);
        await coachAddEducation(formData);
      }

      const deletedEducation = educations?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedEducation?.length > 0) {
        const formData = new FormData();
        formData.append(
          "education_ids",
          `[${deletedEducation?.map((i) => i?.id)}]`
        );

        await coachDeleteEducation(formData);
      }

      // handal testimonial
      const newTestimonial = testimonials?.filter((i) => i?.status === "new");
      for (let index = 0; index < newTestimonial?.length; index++) {
        const element = newTestimonial[index];
        const formData = new FormData();
        formData.append("name", element?.name);
        formData.append("company_name", element?.company_name);
        formData.append("description", element?.description);
        formData.append("testimonial_img", element?.image);
        await coachAddTestimonial(formData);
      }

      const deletedTestimonial = testimonials?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedTestimonial?.length > 0) {
        const formData = new FormData();
        formData.append(
          "tesimonial_ids",
          `[${deletedTestimonial?.map((i) => i?.id)}]`
        );

        await coachDeleteTestimonial(formData);
      }

      // handle experience
      const newExperience = experiences?.filter((i) => i?.status === "new");
      for (let index = 0; index < newExperience?.length; index++) {
        const element = newExperience[index];
        const formData = new FormData();
        formData.append("title", element?.title);
        formData.append("company_name", element?.company_name);
        formData.append("start_date", element?.start_date);
        formData.append("end_date", element?.end_date);
        formData.append("isPresent", element?.isPresent);
        formData.append("workexperience", element?.workexperience);

        await coachAddExperience(formData);
      }

      const deletedExperience = experiences?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedExperience?.length > 0) {
        const formData = new FormData();
        formData.append(
          "experience_ids",
          `[${deletedExperience?.map((i) => i?.id)}]`
        );

        await coachDeleteExperience(formData);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      setisLoading(false);
    }
    getUserFromToken();
    setisLoading(false);
    navigate("/coach/preview");
  };


  //////////////////////////// Start Education /////////////////////////////
  const handleSubmitEducation = (values, { resetForm }) => {
    formikEdu.setValues({
      ...formikEdu.values,
      course: "",
      university_colleage: "",
      passing_year: "",
    });

    seteducations([
      ...educations,
      {
        id: new Date()?.getTime(),
        course: values?.course,
        university_colleage: values?.university_colleage,
        status: "new",
        passing_year: values.passing_year,
      },
    ]);
    resetForm();
  };

  const formikEdu = useFormik({
    initialValues: initialValuesEdu,
    validationSchema: educationSchema,
    onSubmit: handleSubmitEducation,
  });


  // Handle Edit Button Click
  const handleEduEdit = (education) => {
    setMode("education");
    setEditingEducation(true);
    setCurrentEducation(education);
    formikEdu.setValues({
      course: education.course,
      university_colleage: education.university_colleage,
    });
  };

  // Handle Update API Call
  const handleEduUpdate = async (event) => {
    event.preventDefault();
    const formData = {
      id: currentEducation.id,
      course: formikEdu.values.course,
      university_colleage: formikEdu.values.university_colleage,
    };

    try {
      await coachUpdateEducation(formData);
      setEditingEducation(false);
      setCurrentEducation(null);
      //fetchEducations(); // Refresh the list
      //onClickSave();

      getUserFromToken();
    } catch (error) {
      console.error("Error updating education:", error);
    }
  };

  const onRemoveEducation = (id) => {
    const results = JSON.parse(JSON.stringify(educations))?.map((i) => {
      if (id === i?.id) {
        i.status = "deleted";
      }
      return i;
    });
    seteducations(results);
    setEduvisible(false);
    setVisible(false);
  };
  //////////////////////////// End Education /////////////////////////////////

  //////////////////////////// Start Experience /////////////////////////////
  const calculateWorkExperience = (start_date, end_date) => {
    if (!start_date) return "";
    const startDate = new Date(start_date);
    const endDate = end_date ? new Date(end_date) : new Date();
    if (isNaN(startDate) || isNaN(endDate)) return "";
    const diffTime = Math.max(endDate - startDate, 0);
    return (diffTime / (1000 * 60 * 60 * 24 * 365.25)).toFixed(2);
  };

  
  const handleSubmitExperience = (values, { resetForm }) => {
    setDateError("")

    const newExperience = {
      id: editingExperience ? currentExperience.id : new Date().getTime(),
      ...values,
      end_date: values.isPresent ? "Present" : values.end_date,
      workexperience: values.workexperience,
      /*workexperience: calculateWorkExperience(
        values.start_date,
        values.isPresent ? null : values.end_date
      ),*/
      status: editingExperience ? "updated" : "new",
    };

    if (editingExperience) {
      setexperiences((prev) =>
        prev.map((exp) => (exp.id === currentExperience.id ? newExperience : exp))
      );
    } else {
      setexperiences((prev) => [...prev, newExperience]);
    }

    resetForm();
    setEditingExperience(false);
  };

  const formikExp = useFormik({
    initialValues: {
      title: "",
      company_name: "",
      start_date: "",
      end_date: "",
      isPresent: false,
      workexperience: "",
    },
    validationSchema: experienceSchema, // Replace with your schema
    onSubmit: handleSubmitExperience, // Your submit handler
  });

  const onRemoveExperience = (id) => {
    setexperiences((prev) =>
      prev.map((exp) => (exp.id === id ? { ...exp, status: "deleted" } : exp))
    );
  };

  const handleExpEdit = (experience) => {
    setEditingExperience(true);
    setCurrentExperience(experience);

    formikExp.setValues({
      title: experience.title,
      company_name: experience.company_name,
      start_date: experience.start_date,
      end_date: experience.end_date === "Present" ? "" : experience.end_date,
      isPresent: experience.end_date === "Present",
      workexperience: experience.workexperience
      /*workexperience: calculateWorkExperience(
        experience.start_date,
        experience.end_date === "Present" ? null : experience.end_date
      ),*/
    });
  };

  // Handle Update API Call
  const handleExpUpdate = async (event) => {
    event.preventDefault();

    console.log(formikExp.values);

    //const isPresent = formikExp.values?.end_date === "Present";
    const endDate = formikExp.values?.isPresent ? "Present" : formikExp.values?.end_date;

    const formData = {
      id: currentExperience.id,
      title: formikExp.values?.title,
      company_name: formikExp.values?.company_name,
      start_date: formikExp.values?.start_date,
      //end_date: values?.end_date,
      end_date: endDate,//formikExp.values?.isPresent ? "Present" : formikEdu.values?.end_date, // Handle "Present" end_date
      workexperience: formikExp.values?.workexperience,
      //status: "new",
    };

    try {
      await coachUpdateExperience(formData);
      setEditingExperience(false);
      setCurrentExperience(null);
      //fetchExperiences(); // Refresh the list
      //onClickSave();

      getUserFromToken();
    } catch (error) {
      console.error("Error updating experience:", error);
    }
  };

  //////////////////////////// End Experience /////////////////////////////

  //////////////////////////// Start Testmonial /////////////////////////////

  const handleSubmitTestmonial = (values, { resetForm }) => {
    formikTestimonial.setValues({
      ...formikTestimonial.values,
      name: "",
      company_name: "",
      description: "",
      image: "",
    });

    settestimonials([
      ...testimonials,
      {
        id: new Date()?.getTime(),
        name: values?.name,
        company_name: values?.company_name,
        description: values?.description,
        image: values?.image,
        status: "new",
      },
    ]);
    resetForm();
  };

  const onRemovetestimonial = (id) => {
    const results = JSON.parse(JSON.stringify(testimonials))?.map((i) => {
      if (id === i?.id) {
        i.status = "deleted";
      }
      return i;
    });
    settestimonials(results);
    setTestiVisible(false);
    setVisible(false);
  };

  const formikTestimonial = useFormik({
    initialValues: initialtestimonial,
    validationSchema: testimonialSchema,
    onSubmit: handleSubmitTestmonial,
  });

  //////////////////////////// End Testmonial /////////////////////////////


  //////////////////////////// Start Certificate /////////////////////////////
  const handleSubmitCertificate = (values, { resetForm }) => {
    formikCerti.setValues({
      ...formikCerti.values,
      name: "",
      organization: ""
    });

    setcertificates([
      ...certificates,
      {
        id: new Date()?.getTime(),
        name: values?.name,
        organization: values?.organization,
        status: "new",
      },
    ]);
    resetForm();
  };

  const onRemoveCertificate = (id) => {
    const results = JSON.parse(JSON.stringify(certificates))?.map((i) => {
      if (id === i?.id) {
        i.status = "deleted";
      }
      return i;
    });
    setcertificates(results);
    setCertiVisible(false);
    setVisible(false);
  };

  // Handle Edit Button Click
  const handleCerEdit = (certificate) => {
  
    setMode("certificate");
    setEditingCertificate(true);
    setCurrentCertificate(certificate);

    console.log('edit_certificate',certificate);

    formikCerti.setValues({
      name: certificate.name,
      organization: certificate.organization
    });
  };

  // Handle Update API Call
  const handleCerUpdate = async (event) => {
    event.preventDefault();

    console.log(formikCerti.values);

    const formData = {
      id: currentCertificate.id,
      name: formikCerti.values?.name,
      organization: formikCerti.values?.organization
    };

    try {
      await coachUpdateCertificate(formData);
      setEditingCertificate(false);
      setCurrentCertificate(null);
      //fetchExperiences(); // Refresh the list
      //onClickSave();

      getUserFromToken();
    } catch (error) {
      console.error("Error updating certificate:", error);
    }
  };

  const formikCerti = useFormik({
    initialValues: initialValuesCerti,
    validationSchema: certificateSchema,
    onSubmit: handleSubmitCertificate,
  });
  //////////////////////////// End Certificate /////////////////////////////

  const handleDelete = (id, delete_type) => {
    if (delete_type === "education") {
      setDeleteId(id);
      setEduvisible(true);
      setVisible(true);
    } else if (delete_type === "experience") {
      setDeleteId(id);
      setExpVisible(true);
      setVisible(true);
    } else if (delete_type === "testimonial") {
      setDeleteId(id);
      setTestiVisible(true);
      setVisible(true);
    } else if (delete_type === "certificate") {
      setDeleteId(id);
      setCertiVisible(true);
      setVisible(true);
    }
  };

  const calculateExperience = (startDate, endDate) => {
    if (!startDate) return { years: 0, months: 0, days: 0 };

    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(); // If present, use today's date

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    if (days < 0) {
      months -= 1;
      days += new Date(end.getFullYear(), end.getMonth(), 0).getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return { years, months, days };
  };

  const [isErrorDate ,setDateError] = useState("")
  //experience logic
  useEffect(() => {
    const { years, months, days } = calculateExperience(
      formikExp.values.start_date,
      formikExp.values.isPresent ? null : formikExp.values.end_date
    );
    if(formikExp.values.end_date){
      if(formikExp.values.start_date >= formikExp.values.end_date){
        formikExp.setFieldValue("end_date", "")
        setDateError("End date must be greater than start date")
      }else{
        setDateError("")
      }
    }
    if(formikExp.values.isPresent){
      setDateError("")
    }
    formikExp.setFieldValue(
      "workexperience",
      `${years} years, ${months} months, ${days} days`
    );
  }, [formikExp.values.start_date, formikExp.values.end_date, formikExp.values.isPresent]);

  console.log("isErrorDate",isErrorDate)
  const getTotalExperience = () => {
    let totalYears = 0,
      totalMonths = 0,
      totalDays = 0;

    experiences
      ?.filter((exp) => exp.status !== "deleted")
      .forEach((exp) => {
        const { years, months, days } = calculateExperience(
          exp.start_date,
          exp.isPresent ? null : exp.end_date
        );

        totalYears += years;
        totalMonths += months;
        totalDays += days;
      });

    // Adjust overflow of days and months
    if (totalDays >= 30) {
      totalMonths += Math.floor(totalDays / 30);
      totalDays %= 30;
    }
    if (totalMonths >= 12) {
      totalYears += Math.floor(totalMonths / 12);
      totalMonths %= 12;
    }

    return `${totalYears} years, ${totalMonths} months, ${totalDays} days`;
  };

  return (
    <>
      <section className="coach_my_activity py-3">
        <Container>
          <Row className="align-items-center justify-content-center mb-5">
            {window.innerWidth < 500 ? (
              <div>
                <Col className="col">
                  <Nav
                    variant="pills"
                    className="wizard_nav justify-content-center"
                  >
                    <Nav.Item className="active">
                      <NavLink to="/coach/professional-details">
                        <span className="wn_num">4</span>
                        <span>Professional Details</span>
                      </NavLink>
                    </Nav.Item>
                  </Nav>
                </Col>
              </div>
            ) : (
              <Col className="col">
                <Nav
                  variant="pills"
                  className="wizard_nav justify-content-between"
                >
                  <Nav.Item className="active">
                    <NavLink to="/coach">
                      <span className="wn_num">1</span>
                      <span> Personal Information</span>
                    </NavLink>
                  </Nav.Item>

                  <Nav.Item></Nav.Item>

                  <Nav.Item className="active">
                    <NavLink to="/coach/about-yourself">
                      <span className="wn_num">2</span>
                      <span>About Yourself</span>
                    </NavLink>
                  </Nav.Item>

                  <Nav.Item></Nav.Item>

                  <Nav.Item className="active">
                    <NavLink to="/coach/coaching-details">
                      <span className="wn_num">3</span>
                      <span>Coaching Details</span>
                    </NavLink>
                  </Nav.Item>

                  <Nav.Item></Nav.Item>

                  <Nav.Item className="active">
                    <NavLink to="/coach/professional-details">
                      <span className="wn_num">4</span>
                      <span>Professional Details</span>
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Col>
            )}
          </Row>

          {/* EDUCATION FORM */}
          <div className="professional_overlay">
            <Form
              className="profile_edit_forms mt-4 px-3 py-2"
              onSubmit={editingEducation ? handleEduUpdate : formikEdu.handleSubmit}
            >
              <Col sm="12" className="mb-4">
                <Form.Label className="title">Education</Form.Label>

                {/* Existing Education List */}
                {educations
                  ?.filter((i) => i?.status !== "deleted")
                  ?.map((education) => (
                    <Row key={education.id}>
                      <Col className="col-12 mx-auto">
                        <div className="pr_dtls_prvw">
                          <div>
                            <p className="fs-16 fw-500 text_brand_color4 m-0">
                              {education.course}
                            </p>
                            <small className="d-block fs-14 fw-400 text_brand_color4">
                              {education.university_colleage}
                            </small>
                          </div>
                          <div className="d-flex align-items-center">
                            {/*<Button
                              className="p-0 m-2"
                              variant=""
                              onClick={() => handleEduEdit(education)}
                            >
                              <Image height={27} src={edit} />
                            </Button>*/}
                            <Button
                              className="p-0 m-2"
                              variant=""
                              onClick={() => handleDelete(education?.id, "education")}
                            >
                              <Image src={trash} />
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ))}

                {/* Education Form Fields */}
                <Row className="d-flex justify-content-end">
                  <Col
                    className={
                      window.innerWidth < 500
                        ? "col-auto w-100 mt-3"
                        : "col-auto input-width mt-3"
                    }
                  >
                    <Form.Group as={Col}>
                      <Form.Control
                        type="text"
                        placeholder="Course"
                        name="course"
                        value={formikEdu.values.course}
                        onChange={formikEdu.handleChange}
                        isInvalid={
                          formikEdu?.touched?.course && !!formikEdu?.errors?.course
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {formikEdu?.errors?.course}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col className="col-auto mt-3 input-width">
                    <Form.Group as={Col}>
                      <Form.Control
                        type="text"
                        placeholder="University/College"
                        name="university_colleage"
                        value={formikEdu.values.university_colleage}
                        onChange={formikEdu.handleChange}
                        isInvalid={
                          formikEdu?.touched?.university_colleage &&
                          !!formikEdu?.errors?.university_colleage
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {formikEdu?.errors?.university_colleage}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col className="col-auto mt-3">
                    <Button type="submit" variant="success" className="px-4"
                      disabled={!formikEdu.values.course || !formikEdu.values.university_colleage}
                    >
                      {editingEducation ? "Update" : "Add"}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Form>
          </div>

          {/* EXPERIENCE FORM */}
          <div className="professional_overlay">
            <Form
              className="px-3 py-2"
              onSubmit={editingExperience ? handleExpUpdate : formikExp.handleSubmit}
            >
              <Col sm="12" className="mb-4">
                <Form.Label className="title">Experience</Form.Label>

                {/* Existing Experience List */}
                {experiences
                  ?.filter((i) => i?.status !== "deleted")
                  ?.map((experience) => (
                    <Row key={experience.id}>
                      <Col className="col-12 mx-auto">
                        <div className="pr_dtls_prvw">
                          <div>
                            <p className="fs-16 fw-500 text_brand_color4 m-0">
                              {experience.title}
                            </p>
                            <small className="d-block fs-12 fw-400 text_brand_color4">
                              {experience.company_name}
                            </small>
                            <small className="d-block fs-12 fw-400 text_brand_color4">
                              {experience.start_date}
                            </small>
                            <small className="d-block fs-12 fw-400 text_brand_color4">
                              {experience.end_date}
                            </small>
                          </div>
                          <div className="d-flex align-items-center">
                            {/*<Button
                              className="p-0 m-2"
                              variant=""
                              onClick={() => handleExpEdit(experience)}
                            >
                              <Image height={27} src={edit} />
                            </Button>*/}
                            <Button
                              className="p-0 m-2"
                              variant=""
                              onClick={() => handleDelete(experience?.id, "experience")}
                            >
                              <Image src={trash} />
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ))}

                {/* Experience Form Fields */}
                <Row>
                  <Col sm="6" className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Title"
                      name="title"
                      value={formikExp.values.title}
                      onChange={formikExp.handleChange}
                      isInvalid={
                        formikExp?.touched?.title && !!formikExp?.errors?.title
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formikExp?.errors?.title}
                    </Form.Control.Feedback>
                  </Col>
                  <Col sm="6" className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Company"
                      name="company_name"
                      value={formikExp.values.company_name}
                      onChange={formikExp.handleChange}
                      isInvalid={
                        formikExp?.touched?.company_name &&
                        !!formikExp?.errors?.company_name
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formikExp?.errors?.company_name}
                    </Form.Control.Feedback>
                  </Col>

                  <Col sm="3" className="mb-3">
                    {/* <DatePicker
                      selected={formikExp.values.start_date ? new Date(formikExp.values.start_date) : null}
                      onChange={(date) => formikExp.setFieldValue("start_date", date ? moment(date).format("YYYY-MM-DD") : "")}
                      dateFormat="MM/dd/yyyy" // Format displayed to user
                      placeholderText="MM/DD/YYYY"
                      className="form-control"
                      maxDate={new Date()} // Disable future dates
                      showYearDropdown // ✅ Enable year dropdown
                      scrollableYearDropdown // ✅ Allow scrolling through years
                      yearDropdownItemNumber={100}
                    /> */}
                    <Form.Control
                      type="date"
                      placeholder="Start Date"
                      className="calender"
                      name="start_date"
                      value={formikExp.values.start_date}
                      onChange={(e) => {
                        formikExp.setFieldValue("start_date", e.target.value);
                        // formikExp.setFieldValue("end_date", ""); // Reset end date when start date changes
                      }}
                      // onChange={(e) => formikExp.setFieldValue("start_date", e.target.value)}
                      max={new Date().toISOString().split("T")[0]} // ✅ Disable future dates
                      isInvalid={formikExp?.touched?.start_date && !!formikExp?.errors?.start_date}
                    />

                    {formikExp.touched.start_date && formikExp.errors.start_date && (
                      <div className="text-danger">{formikExp.errors.start_date}</div>
                    )}
                  </Col>

                  <Col sm="3" className="mb-3">
                    {/* <DatePicker
                      selected={formikExp.values.isPresent ? null : formikExp.values.end_date ? new Date(formikExp.values.end_date) : null}
                      onChange={(date) => formikExp.setFieldValue("end_date", date ? moment(date).format("YYYY-MM-DD") : "")}
                      dateFormat="MM/dd/yyyy" // Display format
                      placeholderText="MM/DD/YYYY"
                      className="form-control"
                      disabled={formikExp.values.isPresent} // Disable when "isPresent" is checked
                      maxDate={new Date()} // Disable future dates
                    /> */}
                    <Form.Control
                      type="date"
                      placeholder="End Date"
                      name="end_date"
                      className="calender"
                      value={formikExp.values.end_date || ""}
                      onChange={(e) => {
                        // dateCheck(e)
                        formikExp.setFieldValue("end_date", e.target.value)
                        }
                      }
                      max={new Date().toISOString().split("T")[0]} // ✅ Disable future dates
                      disabled={!formikExp.values.start_date}
                      isInvalid={formikExp?.touched?.end_date && !!formikExp?.errors?.end_date}
                    />
                    {isErrorDate && (
                      <div className="text-danger">{isErrorDate}</div>
                    )}
                    {formikExp.touched.end_date && formikExp.errors.end_date && (
                      <div className="text-danger">{formikExp.errors.end_date}</div>
                    )}
                  </Col>
    
                  {/*<Col as={Col} sm="3" className="mb-3">
                    <Form.Control
                      type="date"
                      //placeholder="Start Date"
                      placeholder="MM/DD/YYYY" // Updated placeholder
                      name="start_date"
                      value={formikExp.values.start_date}
                      onChange={formikExp.handleChange}
                      max={new Date().toISOString().split("T")[0]} // Disable future dates
                      isInvalid={formikExp?.touched?.start_date && !!formikExp?.errors?.start_date}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formikExp?.errors?.start_date && formikExp?.touched?.start_date && (
                        <div>{formikExp?.errors?.start_date}</div>
                      )}
                    </Form.Control.Feedback>
                  </Col>

                  <Col as={Col} sm="3" className="mb-3">
                    <Form.Control
                      type="date"
                      placeholder="End Date"
                      name="end_date"
                      value={formikExp.values.isPresent ? "" : formikExp.values.end_date}
                      onChange={formikExp.handleChange}
                      disabled={formikExp.values.isPresent}
                      isInvalid={formikExp?.touched?.end_date && !!formikExp?.errors?.end_date}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formikExp?.errors?.end_date && formikExp?.touched?.end_date && (
                        <div>{formikExp?.errors?.end_date}</div>
                      )}
                    </Form.Control.Feedback>
                  </Col>*/}

                  <Col as={Col} sm="2" className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Present"
                      name="isPresent"
                      disabled={experiences.some((exp) => exp.isPresent)}
                      checked={formikExp.values.isPresent}
                      onChange={(e) =>
                        formikExp.setFieldValue("isPresent", e.target.checked)
                      }
                    />
                  </Col>

                  <Col as={Col} sm="4" className="mb-3">
                      {/*type="number"disabled="true"*/}
                    <Form.Control
                      type="text"
                      disabled="true"
                      placeholder="Experience (In Years)"
                      name="workexperience"
                      value={formikExp.values.workexperience}
                      onChange={formikExp.handleChange}
                      isInvalid={
                        formikExp?.touched?.workexperience &&
                        !!formikExp?.errors?.workexperience
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formikExp?.errors?.workexperience}
                    </Form.Control.Feedback>
                  </Col>

                  

                  <Col sm="3" className="mb-3">
                    <Button type="submit" variant="success" className="px-4"
                      disabled={!formikExp.values.title || !formikExp.values.company_name || !formikExp.values.start_date}
                      >
                      {editingExperience ? "Update" : "Add"}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Form>
          </div>

          {/* CERTIFICATES */}
          <div className="professional_overlay">
            <Form
              className="px-3 py-2"
              onSubmit={editingCertificate ? handleCerUpdate : formikCerti.handleSubmit}
            >
              <Col sm="12" className="mb-4">
                <Form.Label className="title">Certificates</Form.Label>
                <>
                  {certificates
                    ?.filter((i) => i?.status !== "deleted")
                    ?.map((certificate) => (
                      <Row>
                        <Col className="col-12 mx-auto">
                          <div className="pr_dtls_prvw">
                            <div>
                              <p className="fs-16 fw-500 text_brand_color4 m-0">
                                <u>{certificate.name}</u>
                              </p>
                              <small className="d-block fs-12 fw-400 text_brand_color4">
                                {certificate.organization}
                              </small>
                            </div>
                            <div className="d-flex align-items-center">
                              {/*<Button className="p-0 m-2" variant="" 
                              onClick={() => handleCerEdit(certificate)}>
                                <Image height={27} src={edit} />
                              </Button>*/}
                              <Button className="p-0 m-2"
                                variant=""
                                onClick={() =>
                                  handleDelete(certificate?.id, "certificate")
                                  } >
                                <Image src={trash} />
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  <Row>
                    <Col
                      className={
                        window.innerWidth < 500 ? "col-auto mt-3 w-100" : ""
                      }
                    >
                      <Form.Group as={Col} className="" controlId="">
                        <Form.Control
                          type="text"
                          placeholder="Name"
                          name={`name`}
                          value={formikCerti.values.name}
                          onChange={formikCerti.handleChange}
                          isInvalid={
                            formikCerti?.touched?.name &&
                            !!formikCerti?.errors?.name
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikCerti?.errors?.name &&
                            formikCerti?.touched?.name && (
                              <div>{formikCerti?.errors?.name}</div>
                            )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col
                      className={
                        window.innerWidth < 500
                          ? "col-auto mt-3 w-100 mb-2"
                          : ""
                      }
                    >
                      <Form.Group as={Col} className="" controlId="">
                        <Form.Control
                          type="text"
                          placeholder="Issuing Organization"
                          name={`organization`}
                          value={formikCerti.values.organization}
                          onChange={formikCerti.handleChange}
                          isInvalid={
                            formikCerti?.touched?.organization &&
                            !!formikCerti?.errors?.organization
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikCerti?.errors?.organization &&
                            formikCerti?.touched?.organization && (
                              <div>{formikCerti?.errors?.organization}</div>
                            )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col className="mb-3 col-auto">
                      <Button
                        variant="success"
                        type="submit"
                        className="px-4"
                        style={{
                          marginLeft: window.innerWidth < 500 && "250px",
                        }}
                      disabled={!formikCerti.values.name || !formikCerti.values.organization}

                      >
                        {editingCertificate ? "Update" : "Add"}
                      </Button>
                    </Col>
                  </Row>
                </>
              </Col>
            </Form>
          </div>

          <Row className="d-flex justify-content-center">
            <Col sm="12" className="w-100 d-flex justify-content-center mb-4">
              <Button
                variant="outline-success"
                className="px-4 me-3"
                onClick={onClickPreview}
              >
                Preview
              </Button>
            </Col>
          </Row>

          <Col sm="12">
            <div className="d-flex justify-content-between">
              <Button
                variant="outline-success"
                className="px-4"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
              <div>
                <Button
                  variant="success"
                  className="px-4"
                  onClick={onClickSave}
                >
                  {isSubmitting ? (
                    <>
                      <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                      />{' '} &nbsp;
                      {user.is_publish === 'Yes' ? 'Submitting...' :" Publishing..."}
                    </>
                  )  : user.is_publish === 'Yes' ? 'Submit' :"Publish"}
                </Button>
              </div>
            </div>
          </Col>
        </Container>
      </section>

      <Modal
        visible={visible}
        onClickAway={() => setVisible(false)}
        width="500px"
        // height="250px"
        effect="fadeInUp"
      >
        <Row>
          <Col>
            <div className="text-center p-4">
              <h4
                classname="changeColor fs-20"
              >
                Are You sure you want to delete ?
              </h4>

              <Row>
                <Col>
                  <Button
                    className=""
                    color="secondary"
                    variant="contained"
                    style={{
                      margin: "10px",
                      backgroundColor: "#00504E",
                      color: "#fff",
                      width: "5rem",
                      textAlign: "center",
                    }}
                    onClick={() => {
                      if (eduVisible === true) {
                        onRemoveEducation(deleteId);
                      } else if (testiVisible === true) {
                        onRemovetestimonial(deleteId);
                      } else if (certiVisible === true) {
                        onRemoveCertificate(deleteId);
                      } else if (expVisible === true) {
                        onRemoveExperience(deleteId);
                      }
                    }}
                  >
                    <h5 style={{ margin: "auto" }}> Yes </h5>
                  </Button>
                  <Button
                    className=""
                    variant="contained"
                    color="primary"
                    style={{
                      margin: "10px",
                      marginLeft: "4px",
                      // backgroundColor: "#00504E",
                      border: "1px solid #00504E",
                      color: "#111",
                      width: "5rem",
                      textAlign: "center",
                    }}
                    onClick={() => setVisible(false)}
                  >
                    <h5 style={{ margin: "auto" }}>No </h5>
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Modal>
    </>
  );
}

export default CoachProfileProfessionalDetailsComponent;
